import { RootState } from '../index';

export const selectConsultationReview = (state: RootState) => state.consultationsReviews.reviewData;

export const selectRatedConsultations = (state: RootState) => state.consultationsReviews.ratedConsultations;

export const selectConsultationReviewView = (state: RootState) => state.consultationsReviews.view;

export const selectConsultationIsLoading = (state: RootState) => state.consultationsReviews.isLoading;

export const selectTrialSessionReviewModalIsOpen = (state: RootState) =>
  state.consultationsReviews.isTrialSessionReviewModalOpen;

export const selectSubscriptionSessionReviewModalIsOpen = (state: RootState) =>
  state.consultationsReviews.isSubscriptionSessionReviewModalOpen;

export const selectSessionForReview = (state: RootState) => state.consultationsReviews.sessionForReview;
